import { Clickable } from '@carvana/merch-components';
import useShareLink from '~/hooks/common/useShareLink';
import { ActionsContainer, ShareButton } from './Actions.styles';
import Favorite from './Favorite';

export enum ActionsLocations {
  Breadcrumbs = 'Breadcrumbs',
  StickyBanner = 'Sticky Header'
}

type OwnProps = {
  className?: string;
  location: ActionsLocations;
};

export default function Actions({ className, location }: OwnProps) {
  const shareLink = useShareLink();

  return (
    <ActionsContainer className={className}>
      <Clickable
        className="flex items-center justify-end"
        onClick={shareLink}
        data-analytics-id={location}
        data-analytics-attributes={JSON.stringify({
          label: 'Share'
        })}
        data-qa={`${location}-share`}
        title="Share"
      >
        <ShareButton />
        <span className="sr-only">Share</span>
      </Clickable>
      <Favorite
        data-analytics-id={location}
        data-analytics-attributes={JSON.stringify({
          label: 'Favorite'
        })}
        data-qa={`${location}-favorite`}
      />
    </ActionsContainer>
  );
}
